class BrandsOverview extends HTMLElement {
  connectedCallback() {
    this.brandsOverviewList = this.querySelector('[data-brands-overview-list]');
    this.brandsOverviewLetterTemplate = this.querySelector(
      '[data-brands-overview-letter-template]',
    );
    this.brandsOverviewItemTemplate = this.querySelector('[data-brands-overview-item-template]');

    this.alphabetLinks = this.querySelectorAll('[data-alphabet-navigation] a');

    this.data = this.processBrandsData();
    this.updateAlphabetNavigation();
    this.renderBrandsOverview();
  }

  updateAlphabetNavigation() {
    const letters = Object.keys(this.data);
    this.alphabetLinks.forEach((link) => {
      const letter = link.getAttribute('data-letter').toLowerCase();
      if (!letters.includes(letter)) {
        link.removeAttribute('href');
        link.classList.add('opacity-50');
        link.classList.add('pointer-events-none');
      }
    });
  }

  getBrandsData() {
    const data = this.getAttribute('data-brands').split(',');
    return data.map((item) => {
      const [name, collectionUrl] = item.split('|');
      return { name,
        collectionUrl };
    });
  }

  processBrandsData() {
    const unorderedBrandsData = this.getBrandsData();
    const nonDuplicateBrandsData = this.getUniqueBrandsFromData(unorderedBrandsData);

    const orderedBrandsData = Object.groupBy(nonDuplicateBrandsData, ({ name }) => {
      const letter = name?.[0]?.toLowerCase();
      if (!letter) return 'NULL';
      return letter;
    });
    delete orderedBrandsData.NULL;

    return this.sortBrandsData(orderedBrandsData);
  }

  getUniqueBrandsFromData(data) {
    const brands = new Set();

    return data.filter((item) => {
      const isDuplicate = brands.has(item.name);
      if (!isDuplicate) {
        brands.add(item.name);
      }
      return !isDuplicate;
    });
  }

  sortBrandsData(data) {
    return Object.keys(data)
      .sort()
      .reduce(function (map, key) {
        map[key] = data[key].sort((a, b) => a.name.localeCompare(b.name));
        return map;
      }, {});
  }

  renderBrandsOverview() {
    for (const [letter, brands] of Object.entries(this.data)) {
      const cloneLetter = this.brandsOverviewLetterTemplate.content.cloneNode(true);
      const cloneLetterAnchor = cloneLetter.querySelector('[data-letter-anchor]');
      const cloneBrandList = cloneLetter.querySelector('[data-brand-list]');

      cloneLetterAnchor.textContent = letter;
      cloneLetterAnchor.id = `brands-overview-${letter}`;

      // We want to divide the items over 3 columns, but first fill at least 5
      // rows in a column before going to the next. If there are enough items
      // the rows become longer and will 'evenly' distribute across columns
      // (first filling up 1 column to the max rows)
      const rows = Math.max(5, Math.ceil(brands.length / 3));

      brands.forEach((brand, index) => {
        const column = Math.ceil((index + 1) / rows);
        const row = Math.ceil((index + 1) % rows);

        const cloneBrandItem = this.brandsOverviewItemTemplate.content.cloneNode(true);
        cloneBrandItem.firstElementChild.style.setProperty('--column-start', column);
        cloneBrandItem.firstElementChild.style.setProperty('--row-start', row);
        const cloneBrandLink = cloneBrandItem.querySelector('[data-collection-link]');

        cloneBrandLink.textContent = brand.name;
        cloneBrandLink.href = brand.collectionUrl;

        cloneBrandList.appendChild(cloneBrandItem);
      });
      this.brandsOverviewList.appendChild(cloneLetter);
    }
  }
}

customElements.define('brands-overview', BrandsOverview);
